import { Box, Drawer, List, ListItem, ListItemButton, Tooltip } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import SettingsIcon from '@mui/icons-material/Settings';
import { DashboardCustomize } from '@mui/icons-material';
import { AzulButton } from '@the-ksquare-group/azul-ds';
import { NavLink } from 'react-router-dom';
import KsquareLogo from 'assets/images/ksquare-icon-logo.svg';
import { ReactComponent as HomeIcon } from 'assets/images/home-icon.svg';
import { ReactComponent as MyIconDocument } from 'assets/images/document-icon.svg';
import styles from './Sidebar.module.css';
import React from 'react';
import { useAppSelector } from 'app/hooks';
import { selectCurrentUser } from 'features/auth/authSlice';
import { UserRoles } from 'features/auth/authTypes';

interface Props {
  sidebarWidth?: number;
}

export const Sidebar: React.FC<Props> = ({ sidebarWidth }) => {
  const user = useAppSelector(selectCurrentUser);
  const showSettingsItem = user?.role === UserRoles.ADMIN;
  const ksBranding = process.env.REACT_APP_BRANDING == 'yes' ? true : false;

  return (
    <Box component='nav' sx={{ width: { sm: sidebarWidth }, flexShrink: { sm: 0 } }} aria-label='mailbox folders'>
      <Drawer
        variant='temporary'
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: sidebarWidth,
          },
        }}
      />
      <Drawer
        variant='permanent'
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: sidebarWidth,
            background: `linear-gradient(180deg, #1E326B 0%, #296590 51.04%, #3495B4 82.81%, #3495B4 100%)`,
          },
        }}
        open
        anchor='left'
      >
        <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
          <Drawer
            variant='temporary'
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: sidebarWidth,
              },
            }}
          />
          <Drawer
            variant='permanent'
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: sidebarWidth,
                background: `linear-gradient(180deg, #1E326B 0%, #296590 51.04%, #3495B4 82.81%, #3495B4 100%)`,
              },
            }}
            open
            anchor='left'
          >
            <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
              <List sx={{ paddingTop: '24.67px', paddingBottom: '44.67px' }}>
                <ListItem>{ksBranding && <img src={KsquareLogo} alt='' />}</ListItem>
              </List>
            </Box>

            <Box display='flex' flexDirection='column' alignItems='center' justifyContent='start' height='100%'>
              <List style={{ display: 'flex', flexDirection: 'column' }}>
                <NavLink to='/' className={({ isActive }) => (isActive ? styles.active : styles.navlink)}>
                  <Tooltip
                    title='Home'
                    arrow
                    placement='right'
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, 8],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <HomeIcon className={styles.icon} />
                  </Tooltip>
                </NavLink>
                <NavLink to='/documents' className={({ isActive }) => (isActive ? styles.active : styles.navlink)}>
                  <Tooltip
                    title='My Files'
                    arrow
                    placement='right'
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, 8],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <MyIconDocument className={styles.icon} />
                  </Tooltip>
                </NavLink>
                <NavLink to='templates' className={({ isActive }) => (isActive ? styles.active : styles.navlink)}>
                  <Tooltip
                    title='My Templates'
                    arrow
                    placement='right'
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, 8],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <DashboardCustomize className={styles.icon} />
                  </Tooltip>
                </NavLink>
              </List>
            </Box>
            {showSettingsItem && (
              <Box display='flex' flexDirection='column' alignItems='center' justifyContent='flex-end' height='100%'>
                <List sx={{ paddingBottom: '48px' }}>
                  <ListItem sx={{ paddingX: 0 }}>
                    <NavLink to='/settings' className={styles.navlink} style={{ marginBottom: 0 }}>
                      <Tooltip
                        title='Settings'
                        arrow
                        placement='right'
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, 8],
                                },
                              },
                            ],
                          },
                        }}
                      >
                        <SettingsIcon sx={{ color: 'white' }} className={styles.icon} />
                      </Tooltip>
                    </NavLink>
                  </ListItem>
                </List>
              </Box>
            )}
          </Drawer>
        </Box>

        <Box display='flex' flexDirection='column' alignItems='center' justifyContent='start' height='100%'>
          <List>
            <ListItemButton>
              <MailIcon sx={{ color: 'white' }} />
            </ListItemButton>
            <ListItemButton>
              <MailIcon sx={{ color: 'white' }} />
            </ListItemButton>
            <ListItemButton>
              <MailIcon sx={{ color: 'white' }} />
            </ListItemButton>
            <AzulButton label='test' />
          </List>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center' justifyContent='flex-end' height='100%'>
          <List sx={{ paddingBottom: '48px' }}>
            <ListItem>
              <SettingsIcon sx={{ color: 'white' }} />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};
